var formatMoney = function formatMoney(_ref) {
  var amount = _ref.amount,
    symbol = _ref.symbol;
  var rounded = Math.round(amount * 100) / 100;
  var decimals = Number.isInteger(rounded) ? 0 : 2;
  return "".concat(symbol).concat(rounded.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }));
};
export default formatMoney;